angular.module('app').directive('apHeader', ['aprgettext', 'LogOffService', 'TransitionManager', 'SessionService', 'PatientPortalStorageRepository', 'NotificationService', '$rootScope', '$log', 'ContentAttributeService',
    function (gettext, LogOffService, TransitionManager, SessionService, PatientPortalStorageRepository, NotificationService, $rootScope, $log, ContentAttributeService) {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: '/app/partials/header/views/apHeader.html',
            scope: true,
            transclude: false,
            link: function (scope) {

                function getPracticeName() {
                    ContentAttributeService.getPracticeName(false)
                        .then(function(data) {
                            scope.apHeader.practiceName = data;
                        });
                }

                function onLoad() {
                    scope.openmenu = false;
                    
                    var loginUser = PatientPortalStorageRepository.getLoginUser(),
                        activePatient = PatientPortalStorageRepository.getActivePatient();

                    scope.apHeader = {
                        loginUserFullName: loginUser.fullName,
                        activePatientId: activePatient.id,
                        activePatientFullName: activePatient.fullName,
                        patientAuthenticated: SessionService.getPatientAuthenticated(),
                        showHeaderNavigationMenu: SessionService.getShowHeaderNavigationMenu(),
                        responsibleParties: PatientPortalStorageRepository.getActiveResponsibleParties(),
                        get hasResponsibleParties() {
                            return (typeof this.responsibleParties === 'object') && (this.responsibleParties.length > 0);
                        },
                        practiceName: ''
                    };

                    getPracticeName();

                    $rootScope.$broadcast('HeaderData:requested');
                }

                function signOff() {
                    $log.info('User has selected the Sign Out option from the header drop down menu.');

                    LogOffService.logoff().then(function () {
                        TransitionManager.transition({appRoute: 'login'});
                        SessionService.setPatientAuthenticated(false);
                    });
                }

                function toggleMobileNav() {
                    SessionService.setShowMobileNav(!SessionService.getShowMobileNav());
                }

                function setActivePatient(patient) {
                    PatientPortalStorageRepository.setActivePatient(patient.Id, patient.FirstName, patient.LastName, patient.IsPatient);
                    NotificationService.updateNotifications();
                    onLoad();

                    TransitionManager.transition({appRoute: 'dashboard'});
                }

                function accountDetails() {
                    TransitionManager.transition({appRoute: 'accountdetails'});
                }


                scope.updateNotifications = function() {
                    NotificationService.updateNotifications();
                };

                //
                //scope.startNotificationTimer = function() {
                //    NotificationService.startNotificationTimer();
                //};
                //
                //scope.stopNotificationTimer = function() {
                //    NotificationService.stopNotificationTimer();
                //};

                var patientAuthenticatedListener = scope.$on('PatientAuthenticated:updated', function (event, data) {
                    scope.apHeader.PatientAuthenticated = data;
                    scope.apHeader.LoginUserFullName = PatientPortalStorageRepository.getLoginUser().fullName;
                });

                var showHeaderMenuListener = scope.$on('ShowHeaderNavigationMenu:updated', function (event, data) {
                    scope.apHeader.ShowHeaderNavigationMenu = data;
                });
                
                var headerDataListener = $rootScope.$on('HeaderData:requested', function(event, requestor) {
                    var headerData = {
                        loginUserFullName: scope.apHeader.loginUserFullName,
                        activePatientId: scope.apHeader.activePatientId,
                        activePatientFullName: scope.apHeader.activePatientFullName,
                        responsibleParties: scope.apHeader.responsibleParties,
                        hasResponsibleParties: scope.apHeader.hasResponsibleParties,
                        requestor: requestor
                    };
                    $rootScope.$broadcast('HeaderData:updated', headerData);
                });
                
                var responsiblePartyListener = $rootScope.$on('ResponsibleParty:updated', function(event, patientId) {
                    var patient = _.find(scope.apHeader.responsibleParties, { Id: patientId });
                    if(patient)
                        setActivePatient(patient); 
                });

                scope.$on('$destroy', function () {
                    patientAuthenticatedListener();
                    showHeaderMenuListener();
                    headerDataListener();
                    responsiblePartyListener();
                });

                onLoad();

                scope.signOff = signOff;
                scope.setActivePatient = setActivePatient;
                scope.toggleMobileNav = toggleMobileNav;
                scope.accountDetails = accountDetails;
            }
        };
    }]);